import { Box, Card, Typography } from "@material-ui/core";
import AnalyticsCard from "Components/skills/SkillAnalytics/AnalyticsCard";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { checkinSRSDetailsState } from "Recoil/Targets/atom";
import { checkArrayLength } from "src/utils";
import { fetchSkillAnalytics } from "src/utils/skillScore";
import HeaderFilters from "./Common/HeaderFilters";
import ScoreChart from "./Common/ScoreChart";
import SkillQuestions from "./Common/SkillQuestions";
import { useStyles } from "./styles";

const SkillRatingPanel = ({
  skillRatee,
  setSkillRatee,
  selectedSkillName,
  setSelectedSkillName,
  selectedFrequency,
  setSelectedFrequency
}) => {
  const classes = useStyles();
  const [sortSelected, setSortSelected] = useState("Group by question");
  // const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [taggedSkillToTarget, setTaggedSkillToTarget] = useState([]);
  const { skills, enhancedAnalytics, loading } = useRecoilValue(
    checkinSRSDetailsState
  );

  return (
    <Box className={classes.rightSection}>
      <Card>
        <Box p={3}>
          <HeaderFilters
            selectedFrequency={selectedFrequency}
            setSelectedFrequency={setSelectedFrequency}
            skillRatee={skillRatee}
            setSkillRatee={setSkillRatee}
          />
          <ScoreChart
            taggedSkillToTarget={taggedSkillToTarget}
            setTaggedSkillToTarget={setTaggedSkillToTarget}
            selectedSkillName={selectedSkillName}
            setSelectedSkillName={setSelectedSkillName}
            label={`Skills tagged: ${checkArrayLength(skills)}`}
            skillRatee={skillRatee}
          />

          <Box
            textAlign={"center"}
            mt={3}
            className={classes.skillName}
            width="100%"
            position="relative"
          >
            <Typography variant="h6">{selectedSkillName}</Typography>
          </Box>
          {/* AnalyticsCard */}
          {!loading ? (
            <Box pt={3}>
              <Box className={classes.title} mb={1.5}>
                <Typography variant="h6" className="font-14 font-semibold">
                  Coaching recommendations
                </Typography>
              </Box>
              <Box>
                <AnalyticsCard
                  skillAnalytics={fetchSkillAnalytics(enhancedAnalytics)}
                  defaultView={enhancedAnalytics}
                />
              </Box>
            </Box>
          ) : null}
          <SkillQuestions
            selectedSkillName={selectedSkillName}
            setSortSelected={setSortSelected}
            sortSelected={sortSelected}
            skillRatee={skillRatee}
            selectedFrequency={selectedFrequency}
          />
        </Box>
      </Card>
    </Box>
  );
};

export default SkillRatingPanel;
